import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getBanners() {
    yield takeEvery(actions.FETCH_BANNERS_REQUESTED, function* (action) {
        try {
          const banners = yield call(actions.getBanners, action.payload);
          yield put({ type: actions.FETCH_BANNERS_SUCCEEDED, banners });
        } catch (error) {
          yield put({ type: actions.FETCH_BANNERS_FAILED, error: error.message });
        }
    });
}


export function* getBanner() {
    yield takeEvery(actions.FETCH_BANNER_REQUESTED, function* (action) {
        try {
            const banner = yield call(actions.getBanner, action.payload);
            yield put({ type: actions.FETCH_BANNER_SUCCEEDED, banner: banner.banner_info });
        } catch (error) {
            yield put({ type: actions.FETCH_BANNER_FAILED, error: error.message });
        }
    });
}

export function* deleteBanner() {
  yield takeEvery(actions.DELETE_BANNER_REQUESTED, function* (action) {
      try {
          const banner = yield call(actions.deleteBanner, action.payload);
          yield put({ type: actions.DELETE_BANNER_SUCCEEDED, bannerDeleted: banner });
      } catch (error) {
          yield put({ type: actions.DELETE_BANNER_FAILED, error: error.message });
      }
  });
}


export default function* rootSaga() {
  yield all([
    fork(getBanners),
    fork(getBanner),
    fork(deleteBanner)
  ]);
}
